<header class="flex header">
  @if (model && model.id) {
    <h2>{{ 'Modal_Model.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_Model.Add' | translate }}</h2>
  }

  <p-button (onClick)="onClose()" icon="pi pi-times" />
</header>
<section class="content">
  <form [formGroup]="formModelGroup" class="col">
    <!-- Name -->
    <div class="form-box">
      <label for="name" ariaRequired="true">
        {{ 'Modal_Model.Name' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="name" formControlName="name" />
    </div>
    <!-- Description -->
    <div class="form-box">
      <label for="description" ariaRequired="true">
        {{ 'Modal_Model.Description' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="description" formControlName="description" />
    </div>
    <!-- Type -->
    <div class="form-box">
      <label for="assetType" ariaRequired="true">
        {{ 'Modal_Model.Type' | translate }}
      </label>
      <p-autocomplete
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        fluid
        formControlName="assetType"
        optionLabel="name"
        [suggestions]="filteredTypes"
        (completeMethod)="typesTypeahead($event)"
        class="w-full"
      />
    </div>
    <!-- Model Property -->
    <div class="form-box">
      <label for="propertiesReference">
        {{ 'Modal_Model.ModelProperty' | translate }}
      </label>
      <p-autocomplete
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        fluid
        formControlName="modelProperty"
        optionLabel="name"
        [suggestions]="filteredModelProperties"
        (completeMethod)="modelPropertyTypeahead($event)"
        class="w-full"
      />
    </div>

    <ul class="col-sm">
      <li *ngFor="let property of selectedModelProperties" class="justify-between max-w-fit row-start-center font-medium px-2 py-1 rounded-full border-2">
        <p class="px-2">{{ property.name }}</p>
        <button (click)="removeProperty(property)" class="border-none">
          <span class="material-icons">close</span>
        </button>
      </li>
    </ul>
    @if (isKnittingMachineAssetType) {
      <div class="form-box">
        <label for="propertiesReference">
          {{ 'Modal_Model.FabricCategory' | translate }}
        </label>
        <p-autocomplete
          appendTo="body"
          [panelStyle]="{ width: '100%' }"
          fluid
          formControlName="fabricCategory"
          optionLabel="code"
          [suggestions]="filterFabricCategories"
          (completeMethod)="fabricCategoriesTypeahead($event)"
          class="w-full"
        />
      </div>

      <ul class="col-sm">
        <li *ngFor="let category of selectedFabricCategories" class="justify-between max-w-fit row-start-center font-medium px-2 py-1 rounded-full border-2">
          <p class="px-2">{{ category.code }}</p>
          <p-button icon="pi pi-times" variant="text" (click)="removeFabricCategory(category)" />
        </li>
      </ul>
    }
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" [disabled]="isButtonDisabled()" (click)="onSave()" />

  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
